import { useCallback, useState } from 'react'
import { UserType } from 'types/user'
import { useSkip } from 'hooks/effect'
import { db } from 'firebase/index'

type SearchLinkingUser = {
  isMatched: boolean
  matchedUsers: UserType[]
  searchUser: () => void
}

const fetchUserById = (keyword: string): Promise<UserType[]> => {
  return db
    .collection('users')
    .doc(keyword)
    .get()
    .then((snapshot) => {
      if (!snapshot.exists) return []
      const data = snapshot.data() as UserType
      if (!data.user_id) {
        data.user_id = snapshot.id
      }
      return [data]
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}

const fetchUserByName = (keyword: string): Promise<UserType[]> => {
  return db
    .collection('users')
    .where('name', '==', keyword)
    .get()
    .then((snapshots) => {
      const users: UserType[] = []
      snapshots.forEach((snapshot) => {
        const data = snapshot.data() as UserType
        if (!data.user_id) {
          data.user_id = snapshot.id
        }
        users.push(data)
      })
      return users
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}

const fetchUserByTel = (keyword: string): Promise<UserType[]> => {
  return db
    .collection('users')
    .where('tel', '==', keyword)
    .get()
    .then((snapshots) => {
      const users: UserType[] = []
      snapshots.forEach((snapshot) => {
        const data = snapshot.data() as UserType
        if (!data.user_id) {
          data.user_id = snapshot.id
        }
        users.push(data)
      })
      return users
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}

const useSearchLinkingUser = (keyword: string): SearchLinkingUser => {
  const [matchedUsers, setMatchedUsers] = useState<UserType[]>([])
  const [isMatched, setMatched] = useState<boolean>(true)

  const searchUser = useCallback(async () => {
    // ユーザー名の完全一致検索
    const usersByName = await fetchUserByName(keyword)
    if (usersByName.length > 0) {
      setMatchedUsers([...usersByName])
      setMatched(true)
      return
    }
    // 電話番号の完全一致検索
    const usersByTel = await fetchUserByTel(keyword)
    if (usersByTel.length > 0) {
      setMatchedUsers([...usersByTel])
      setMatched(true)
      return
    }
    // ユーザーIDの完全一致検索
    const usersById = await fetchUserById(keyword)
    if (usersById.length > 0) {
      setMatchedUsers([...usersById])
      setMatched(true)
      return
    }
    // 見つからなかった場合
    setMatched(false)
  }, [keyword])

  useSkip(
    () => {
      if (keyword !== '') return
      setMatchedUsers([])
      setMatched(true)
    },
    [keyword],
    1
  )

  return {
    isMatched,
    matchedUsers,
    searchUser,
  }
}

export default useSearchLinkingUser
